/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptCreativeMapping } from '../models/V3StackAdaptCreativeMapping';
import { HttpFile } from '../http/http';

/**
* A map of all creative ids on the campaign to their stackadapt campaign ad ids
*/
export class V3StackAdaptCreativeMap {
    /**
    * List of creative mappings
    */
    'creatives'?: Array<V3StackAdaptCreativeMapping>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creatives",
            "baseName": "creatives",
            "type": "Array<V3StackAdaptCreativeMapping>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCreativeMap.attributeTypeMap;
    }

    public constructor() {
    }
}

